<template>
  <div>
    <div class="d-flex flex-wrap">
      <div class="col-md-12">
        <h4 class="mt-4 mb-3 title-custom">
          Cambios solicitados: Kilometraje
        </h4>
      </div>
    </div>

    <div class="d-flex flex-wrap">
      <div class="col-md-12">
        <ul class="nav nav-tabs justify-content-end" id="myTab" role="tablist">
          <li class="nav-item" role="presentation">
            <button
              class="nav-link active"
              id="home-tab"
              data-bs-toggle="tab"
              data-bs-target="#home-tab-pane"
              type="button"
              role="tab"
              aria-controls="home-tab-pane"
              aria-selected="true"
            >
              Kilometraje
            </button>
          </li>
          <li class="nav-item" role="presentation">
            <button
              class="nav-link"
              id="contact-tab"
              data-bs-toggle="tab"
              data-bs-target="#contact-tab-pane"
              type="button"
              role="tab"
              aria-controls="contact-tab-pane"
              aria-selected="false"
            >
              Mensajes
            </button>
          </li>
        </ul>
        <div class="tab-content" id="myTabContent">
          <div
            class="tab-pane fade show active"
            id="home-tab-pane"
            role="tabpanel"
            aria-labelledby="home-tab"
            tabindex="0"
          >
            <h4 class="title-custom mt-4">Datos originales</h4>

            <div class="row mt-4">
              <div class="col-md-3">
                <p>
                  Kilometraje:
                  <span class="label-custom-bold">{{
                    datosPoliza.INCISO[0].KILOMETRAJE
                  }}</span>
                </p>
              </div>
              <div class="col-md-9">
                <p>
                  Descripción:
                  <span class="label-custom-bold">{{
                    datosPoliza.INCISO[0].VEHICULO
                  }}</span>
                </p>
              </div>
              <div class="col-md-3">
                <p>
                  Marca:
                  <span class="label-custom-bold">{{
                    datosPoliza.INCISO[0].MARCA
                  }}</span>
                </p>
              </div>
              <div class="col-md-3">
                <p>
                  Modelo:
                  <span class="label-custom-bold">{{
                    datosPoliza.INCISO[0].MODELO
                  }}</span>
                </p>
              </div>
              <div class="col-md-3">
                <p>
                  Submarca:
                  <span class="label-custom-bold">{{
                    datosPoliza.INCISO[0].SUBMARCA
                  }}</span>
                </p>
              </div>
              <div class="col-md-3">
                <p>
                  Numero de Serie:
                  <span class="label-custom-bold">{{
                    datosPoliza.INCISO[0].SERIE
                  }}</span>
                </p>
              </div>
              <div class="col-md-6">
                <p>
                  Numero de identificación vehicular (NIV):
                  <span class="label-custom-bold"></span>
                </p>
              </div>
              <div class="col-md-6">
                <p>
                  Número de motor:
                  <span class="label-custom-bold">{{
                    datosPoliza.INCISO[0].MOTOR
                  }}</span>
                </p>
              </div>
              <div class="col-md-12">
                <p>
                  Placas:
                  <span class="label-custom-bold">{{
                    datosPoliza.INCISO[0].PLACA
                  }}</span>
                </p>
              </div>
            </div>

            <h4 class="title-custom mt-4">Datos a modificar</h4>

            <div class="row mt-4">
              <div class="col-md-3">
                <p>
                  Kilometraje:
                  <input type="text" class="form-control" v-model="km" />
                </p>
              </div>
              <div class="col-md-9">
                <p>
                  Descripción:
                  <span class="label-custom-bold">{{
                    datosPoliza.INCISO[0].VEHICULO
                  }}</span>
                </p>
              </div>
              <div class="col-md-3">
                <p>
                  Marca:
                  <span class="label-custom-bold">{{
                    datosPoliza.INCISO[0].MARCA
                  }}</span>
                </p>
              </div>
              <div class="col-md-3">
                <p>
                  Modelo:
                  <span class="label-custom-bold">{{
                    datosPoliza.INCISO[0].MODELO
                  }}</span>
                </p>
              </div>
              <div class="col-md-3">
                <p>
                  Submarca:
                  <span class="label-custom-bold">{{
                    datosPoliza.INCISO[0].SUBMARCA
                  }}</span>
                </p>
              </div>
              <div class="col-md-3">
                <p>
                  Numero de Serie:
                  <span class="label-custom-bold">{{
                    datosPoliza.INCISO[0].SERIE
                  }}</span>
                </p>
              </div>
              <div class="col-md-6">
                <p>
                  Numero de identificación vehicular (NIV):
                  <span class="label-custom-bold"></span>
                </p>
              </div>
              <div class="col-md-6">
                <p>
                  Número de motor:
                  <span class="label-custom-bold">{{
                    datosPoliza.INCISO[0].MOTOR
                  }}</span>
                </p>
              </div>
              <div class="col-md-12">
                <p>
                  Placas:
                  <span class="label-custom-bold">{{
                    datosPoliza.INCISO[0].PLACA
                  }}</span>
                </p>
              </div>
            </div>

            <div class="row mt-4">
              <div class="col-md-12 mt-4 d-flex justify-content-end">
                <button
                  class="btn btn-primary btn-rounded ml-4"
                  @click="cotizarEndoso"
                >
                  Cotizar
                </button>
                <button
                  class="btn btn-primary btn-rounded ml-4"
                  @click="guardarCambios"
                >
                  Emitir
                </button>
              </div>
            </div>
          </div>
          <div
            class="tab-pane fade"
            id="contact-tab-pane"
            role="tabpanel"
            aria-labelledby="contact-tab"
            tabindex="0"
          >
            <div class="row mt-4">
              <div class="col-md-8">
                <p>Mensaje de Suscripción:</p>
                <p>Se envía cotización.</p>
              </div>
              <div class="col-md-4">
                <p>Fecha</p>
                <p>24/08/2022</p>
              </div>
              <div class="col-md-12 mt-3">
                <textarea class="form-control" v-model="comentario"></textarea>
              </div>
              <div class="col-md-12 mt-4">
                <label
                  >Adjunta tus archivos aquí (formato .pdf)
                  <input type="file" class="ml-2" id="file" />
                </label>
              </div>
              <div class="col-md-12 mt-4 d-flex justify-content-end">
                <button
                  class="btn btn-primary btn-rounded"
                  @click="enviarArchivo"
                >
                  Enviar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { format, date } from "../../../../assets/helpers";
import moment from "moment";

export default {
  props: {
    datosPoliza: Object,
    kilometraje: Number,
    altaFolioInnova: Function,
    endosoCoberturas: Object,
  },
  data() {
    return {
      km: this.datosPoliza.INCISO[0].KILOMETRAJE,
      comentario: "",
      archivos: [],
      totalDescuentos: 0,
    };
  },
  methods: {
    guardarCambios() {
      this.calculaPrimas();
      this.$emit("update:kilometraje", this.km);
      this.altaFolioInnova({}, "A2", "A", "");
    },
    async cotizarEndoso() {
      await this.datosPoliza.INCISO[0].COBERTURAS.map((cob, i) => {
        const rcTemp = this.datosPoliza.INCISO[0].COBERTURAS.find(
          (cob) => cob.CLAVECOBERTURA === "RC"
        );
        const sumaTemp =
          cob.CLAVECOBERTURA === "ERC"
            ? rcTemp.SUMAASEGURADA
            : cob.SUMAASEGURADA;

        this.getCalcCobs(
          cob.CLAVECOBERTURA,
          sumaTemp,
          cob.DEDUCIBLE,
          cob.PRIMA,
          i
        );

        if (i === this.datosPoliza.INCISO[0].COBERTURAS.length - 1) {
          this.$swal.fire("Cotizado exitosamente");
        }
      });
    },
    async getCalcCobs(nomenclatura, sumaTemp, deducible, prima, index) {
      const payload = {
        metodo: "GET_CALCULO_COBS_CA",
        data: {
          ClaveVehiculo: this.datosPoliza.INCISO[0].CVVEHICULO,
          ModeloVehiculo: this.datosPoliza.INCISO[0].MODELO,
          ClaveCobertura: nomenclatura,
          SumaAsegurada: sumaTemp,
          ValorAuto: this.datosPoliza.VALORVEHICULO,
          Deducible: deducible == "NA" ? "" : deducible,
          EstadoUniverse: this.datosPoliza.ESTADOUNIVERSE,
          PorcentajeDescuento: this.totalDescuentos,
          Kilometraje: this.km,
          ClaveAgente: this.datosPoliza.CVAGENTE,
          primaDmpt: this.getPrima("DMPT"),
          primaDmpp: this.getPrima("DM"),
          primaRoboTotal: this.getPrima("RT"),
          primaRespCivil: this.getPrima("RC"),
          primaGastosMedico: this.getPrima("GM"),
          deducibleDMPP: this.getDeducible("DM"),
          deducibleDMPT: this.getDeducible("DMPT"),
          deducibleRT: this.getDeducible("RT"),
          VigenciaInicio: format.date(
            this.datosPoliza.INIVIGENCIA,
            "dd/mm/aaaa"
          ),
          VigenciaFin: format.date(this.datosPoliza.FINVIGENCIA, "dd/mm/aaaa"),
          TipoVigencia: this.datosPoliza.TIPOVIGENCIA,
          BuroCredito: "",
          TIPOMOVIMIENTO: "A2",
          PRIMACOBERTURA: prima,
        },
      };

      await this.$store.dispatch("metodoPost", payload).then(() => {
        const resp = this.$store.getters.getRespuestaREST;
        this.datosPoliza.INCISO[0].COBERTURAS[index].PRIMA = resp[0];
      });
    },
    async getDescuento() {
      const payload = {
        metodo: "GET_DESCUENTOS_CA",
        data: {
          Genero:
            this.datosPoliza.ASEGURADO[0].SEXO === "MASCULINO" ? "M" : "F",
          Edad: date.getAge(
            format.date(
              this.datosPoliza.ASEGURADO[0].FECHANACIMIENTO,
              "aaaa/mm/dd"
            )
          ),
          ClaveVehiculo: this.datosPoliza.INCISO[0].VEHICULO,
          Kilometraje: this.datosPoliza.INCISO[0].KILOMETRAJE
            ? +this.datosPoliza.INCISO[0].KILOMETRAJE.replaceAll(",", "")
            : 0,
        },
      };

      await this.$store.dispatch("metodoPost", payload).then(() => {
        const descuentos = this.$store.getters.getRespuestaREST.map(
          (descuento) => descuento.ValorInicio
        );
        this.totalDescuentos = descuentos.join("-");
      });
    },
    async enviarArchivo() {
      const file = document.getElementById("file").files[0];

      if (file) {
        const promise = convert.convertFileToBase64(file);

        promise.then((result) => {
          this.altaFolioInnova(
            {
              base64: result,
              nombre: file.name,
              contentType: file.type,
              extension: "pdf",
            },
            "B7",
            "B",
            this.comentario
          );
        });
      }
    },
    async calculaPrimas() {
      const existsRcUsa = this.datosPoliza.INCISO[0].COBERTURASASEGURADAS.findIndex(
        (bas) => bas.NOMENCLATURA === "RCU"
      );

      const config = {
        metodo: "GET_CALCULO_PRIMAS_CA",
        data: {
          SumaPrimas: this.sumarCoberturas(),
          TipoVigencia: this.datosPoliza.FORMAPAGO,
          VigenciaInicio: format.date(
            this.datosPoliza.INIVIGENCIA,
            "dd/mm/aaaa"
          ),
          VigenciaFin: format.date(this.datosPoliza.FINVIGENCIA, "dd/mm/aaaa"),
          CobRcUsa: existsRcUsa !== -1 ? 1 : 0,
          Tipo: "E",
        },
      };
      await this.$store.dispatch("metodoPost", config);

      let detalles = this.$store.getters.getRespuestaREST;

      this.$emit("update:endosoCoberturas", {
        periodo: detalles[0].DESCRIPCION,
        duración: this.diasEntreFechas(this.iniVigencia, this.maxVigencia),
        primerRecibo: detalles[0].RECIBO1,
        subsecuente: detalles[0].RECIBOSUB,
        primaNeta: detalles[0].PRIMANETA,
        recargoFraccionado: detalles[0].RECARGO,
        gastosExpedicion: detalles[0].GASTOSEXPEDICION,
        subtotal: detalles[0].SUBTOTAL,
        iva: detalles[0].IVA,
        articulo101: detalles[0].ARTICULO101,
        ivaArticulo101: detalles[0].IVA101,
        total: detalles[0].PRIMATOTAL,
      });
    },
    sumarCoberturas() {
      let totalCoberturas = 0;

      this.datosPoliza.INCISO[0].COBERTURAS.map(
        (cob) => (totalCoberturas = totalCoberturas + +cob.PRIMA)
      );

      return totalCoberturas;
    },
    getDeducible(id) {
      let cobertura = [];

      cobertura = this.datosPoliza.INCISO[0].COBERTURAS.find(
        (cob) => cob.CLAVECOBERTURA == id
      );

      if (!cobertura) {
        return "";
      }
      return cobertura.DEDUCIBLE;
    },
    getPrima(id) {
      let cobertura = [];

      cobertura = this.datosPoliza.INCISO[0].COBERTURAS.find(
        (cob) => cob.CLAVECOBERTURA == id
      );

      if (!cobertura) {
        return "";
      }
      return cobertura.PRIMA;
    },
    diasEntreFechas(fecha1, fecha2) {
      const date1 = moment(fecha1);
      const date2 = moment(fecha2);

      return date2.diff(date1, "days");
    },
  },
  async mounted() {
    await this.getDescuento();
  },
};
</script>
